export default __webpack_public_path__ + "static/media/foldover.b4559541.jpg";